import { InputHTMLAttributes } from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { ExtractNativePropsFromDefault } from 'typeHelpers/ExtractNativePropsFromDefault';
import twMerge from 'utils/twMerge';

type NativeProps = ExtractNativePropsFromDefault<
    InputHTMLAttributes<HTMLInputElement>,
    never,
    'name' | 'id' | 'onBlurCapture' | 'onChange' | 'onKeyPress'
>;

type RangeSliderInputProps = NativeProps & {
    fieldRef?: ControllerRenderProps<any, any>;
    value?: number | string;
    isDisabled?: boolean;
    ariaLabel?: string;
};

export const RangeSliderInput: FC<RangeSliderInputProps> = ({ className, isDisabled, ariaLabel, ...props }) => {
    return (
        <input
            aria-label={ariaLabel}
            className={twMerge(
                'ml-2 h-8 w-16 rounded-sm border border-primary bg-white text-center text-small text-primary focus:outline focus:outline-2 focus:outline-green/30',
                isDisabled && 'pointer-events-none cursor-no-drop opacity-50',
                className,
            )}
            {...props.fieldRef}
            {...props}
            type="number"
        />
    );
};
